module.exports = __webpack_public_path__ + "static/01-1f01f210bf021653c39fa5b5c51dd7ae.png";